export default "__VITE_ASSET__D_PA2MJo__"